import { render, staticRenderFns } from "./ReturnReasons.vue?vue&type=template&id=65d6d91c&scoped=true&lang=pug&"
import script from "./ReturnReasons.vue?vue&type=script&lang=js&"
export * from "./ReturnReasons.vue?vue&type=script&lang=js&"
import style0 from "./ReturnReasons.vue?vue&type=style&index=0&id=65d6d91c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6d91c",
  null
  
)

/* custom blocks */
import block0 from "./ReturnReasons.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports